import React from 'react';
import { View, Pressable, StyleSheet, Platform } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

function ChecklistItemRow({ item, completed, onPress, colors }) {
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={`${item.label}${completed ? ', completed' : ''}`}
      accessibilityHint={item.hint}
      style={({ hovered, pressed }) => [
        styles.row,
        (hovered || pressed) && { backgroundColor: colors.solid_color_tertiary },
      ]}
    >
      <View style={styles.icon}>
        <Icon
          name={completed ? 'circle-check' : item.icon}
          size={16}
          color={colors.text_color_secondary}
        />
      </View>
      <View style={styles.copy}>
        <Text style={[
          styles.title,
          { color: completed ? colors.text_color_tertiary : colors.text_color_primary },
        ]}>
          {item.label}
        </Text>
        {!completed && (
          <Text style={[styles.hint, { color: colors.text_color_tertiary }]}>
            {item.hint}
          </Text>
        )}
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  row: {
    minHeight: Platform.OS === 'web' ? 48 : 52,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 8,
    gap: 10,
  },
  icon: {
    width: 20,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  copy: { flex: 1, minWidth: 0, gap: 3 },
  title: { fontSize: 13, lineHeight: 18, fontWeight: '500' },
  hint: { fontSize: 11, lineHeight: 16 },
});

export default React.memo(ChecklistItemRow);
